
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'log-observation-dialog',
    components: { DialogTemplate },
})
export default class LeaveDialog extends Mixins<MixinInterface>() {
    @Prop() props!: any

    get title() {
        return this.props.title
            ? this.props.title
            : this.$t("common_fe['unsavedChanges.dialog.title']")
    }

    get text() {
        return this.props.text
            ? this.props.text
            : this.$t("common_fe['unsavedChanges.dialog.text']")
    }

    get update() {
        return this.props.update
    }

    discard() {
        if (this.props.discard) {
            this.props.discard()
        }
        return this.$emit('close', true)
    }

    updatesLoading = false

    async saveChanges() {
        try {
            this.updatesLoading = true
            await this.update()
            this.$emit('close', true)
        } finally {
            this.updatesLoading = false
        }
    }
}
